export const HELP_GOALS_INDIVIDUAL_LESSONS = [
  {
    title: 'Бесплатно проконсультируем',
    description:
      'Наши менеджеры всегда на&nbsp;связи в&nbsp;чате в&nbsp;мессенджерах. Мы&nbsp;поможем вам определиться с&nbsp;группой или выбрать преподавателя, расскажем про наши форматы и&nbsp;предложим тест на&nbsp;уровень языка!',
  },
  {
    title: 'Составим роудмэп',
    description:
      'Исходя из&nbsp;ваших целей и&nbsp;предпочтений, мы&nbsp;составим учебный план, где будет только самое необходимое и&nbsp;много практики. С&nbsp;таким роудмэпом вы&nbsp;будете наглядно видеть, какие темы предстоит пройти и&nbsp;в&nbsp;какие сроки, а&nbsp;также будете отслеживать свой прогресс',
  },
  {
    title: 'Доведем до цели',
    description:
      'Мы&nbsp;поможем вам подготовиться к&nbsp;экзамену или собеседованию, выучить английский для себя, для работы или путешествий!',
  },
];

export const HOW_WE_WORK_FOR_COMPANIES = [
  {
    title: 'Бесплатная консультация',
    description:
      'Расскажите нам о&nbsp;своих целях и&nbsp;задачах, и&nbsp;мы&nbsp;предложим решение, которое идеально подойдет для вашей компании.',
  },
  {
    title: 'Тест-драйв курса',
    description:
      'Мы&nbsp;проведем бесплатное пробное занятие для вашей команды, чтобы вы&nbsp;оценили формат и&nbsp;качество обучения.',
  },
  {
    title: 'Тестирование сотрудников',
    description: 'Мы&nbsp;проверим уровень языка, чтобы сформировать максимально эффективные группы',
  },
  {
    title: 'Старт программы ',
    description:
      'Наши преподаватели начнут обучение, а&nbsp;вы&nbsp;получите первые результаты уже через несколько недель.',
  },
];
